import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "years", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.yearsAmount)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "floating-years__label",
        class: _normalizeClass({ hide: _ctx.hide }),
        style: _normalizeStyle(_ctx.mousePosition)
      }, [
        _createElementVNode("p", null, _toDisplayString(_ctx.yearsAmount) + "+", 1),
        _hoisted_1
      ], 6))
    : _createCommentVNode("", true)
}